import type { ComponentProps } from 'react'

export type StaticImageData = string | { src: string; width?: number; height?: number }

type Props = Omit<ComponentProps<'img'>, 'src'> & { src: StaticImageData; priority?: boolean; quality?: number; placeholder?: string; unoptimized?: boolean; fill?: boolean; sizes?: string }

/** `next/image` reduced to an <img>: Vite serves the PNGs as URLs. */
export default function Image({ src, priority: _p, quality: _q, placeholder: _ph, unoptimized: _u, fill: _f, alt, ...rest }: Props) {
  const url = typeof src === 'string' ? src : src.src
  return <img src={url} alt={alt ?? ''} loading={_p ? 'eager' : 'lazy'} {...rest} />
}
